import { parseAsInteger, useQueryState } from 'nuqs';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';

export type HelpMeChooseFooterProps = {
  backwardsLabel?: string;
  backwardsClick?: () => void;
  forwardLabel?: string;
  forwardVariant?: 'primary' | 'secondary';
  forwardIcon?: React.ReactNode;
  forwardClick?: () => void;
};
export const HelpMeChooseFooter: React.FC<HelpMeChooseFooterProps> = ({
  backwardsLabel,
  backwardsClick,
  forwardLabel,
  forwardVariant,
  forwardIcon,
  forwardClick,
}) => {
  const [step] = useQueryState('step', parseAsInteger.withDefault(0));

  return (
    <div className="HelpMeChoose__footer fixed lg:relative w-full lg:w-sm bottom-0 left-0 flex-shrink-0 lg:mx-auto lg:justify-center lg:my-comfy-xl px-comfy-sm py-snug-xl flex flex-row gap-comfy-sm">
      <div className="flex-1">
        {step > 0 && (
          <ButtonStyle
            purpose="neutral"
            variant="secondary"
            size="md"
            fullWidth
          >
            <button className="w-full" type="button" onClick={backwardsClick}>
              {backwardsLabel}
            </button>
          </ButtonStyle>
        )}
      </div>
      <div className="flex-1">
        <ButtonStyle
          iconAfter={forwardIcon}
          variant={forwardVariant}
          size="md"
          fullWidth
        >
          <button type="button" onClick={forwardClick}>
            {forwardLabel}
          </button>
        </ButtonStyle>
      </div>
    </div>
  );
};
